import UserManagement from '../components/user-management';

const UserManagementPage = () => {
    return <UserManagement />;
};

export default UserManagementPage;
